import React, { useEffect, useRef } from "react";
import useStyles from "./styles";
import CakeImage from "../../../assets/images/cake-promo.png";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { getSettingByKey } from "../../../helpers/common";

const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <circle cx="9" cy="9" r="9" fill="rgba(255,255,255,0.15)" />
    <path
      d="M5 9l3 3 5-5"
      stroke="#fff"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

const CakePromoSection = () => {
  const classes = useStyles();
  const sectionRef = useRef(null);

  const settings = useSelector((state) => state.settings.data);
  const showCakeSectionSetting = getSettingByKey(
    settings,
    "show_cake_section_on_main_website",
  );

  const showCakeSection = showCakeSectionSetting?.value === "yes";

  const bulletPoints = [
    { text: "Custom name & message on cake", emoji: "✍️" },
    { text: "Multiple flavors available", emoji: "🍫" },
    { text: "Fresh & hygienic preparation", emoji: "✨" },
    { text: "Perfect for every celebration", emoji: "🎉" },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(classes.visible);
          }
        });
      },
      { threshold: 0.15 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [classes]);

  if (!showCakeSection) {
    return null;
  }

  return (
    <section className={classes.promoSec} ref={sectionRef}>
      {/* Background decorations */}
      <div className={classes.bgOrb1} />
      <div className={classes.bgOrb2} />
      <div className={classes.bgOrb3} />
      <div className={classes.bgGrid} />

      <div className="container">
        <div className={classes.innerWrap}>
          {/* ── LEFT: content ── */}
          <div className={classes.contentSide}>
            <div className={classes.badgeRow}>
              <span className={classes.badge}>
                <span className={classes.badgeDot} />
                New Launch
              </span>
            </div>

            <h2 className={classes.heading}>
              Celebrate with
              <br />
              <span className={classes.headingAccent}>Personalized</span>
              <br />
              Cakes
            </h2>

            <p className={classes.subtext}>
              Every bite tells your story — handcrafted cakes made exactly the
              way you imagine them.
            </p>

            <ul className={classes.bulletList}>
              {bulletPoints.map((point, i) => (
                <li
                  key={i}
                  className={classes.bulletItem}
                  style={{ animationDelay: `${0.1 * i}s` }}
                >
                  <span className={classes.bulletIcon}>
                    <CheckIcon />
                  </span>
                  <span>{point.text}</span>
                </li>
              ))}
            </ul>

            <div className={classes.ctaRow}>
              <Link
                to="/cake-store"
                className={classes.ctaButton}
                target="_blank"
              >
                <span>Explore Cake Store</span>
                <span className={classes.ctaArrow}>
                  <ArrowIcon />
                </span>
              </Link>
              <span className={classes.ctaNote}>🎂 100+ designs available</span>
            </div>
          </div>

          {/* ── RIGHT: image ── */}
          <div className={classes.imageSide}>
            <div className={classes.imageFrame}>
              <div className={classes.imageGlow} />
              <div className={classes.imageRing} />
              <img
                src={CakeImage}
                alt="Personalized Celebration Cake"
                className={classes.cakeImg}
              />
              {/* Floating tag */}
              <div className={classes.floatTag1}>
                <span>🎂</span> Custom Design
              </div>
              <div className={classes.floatTag2}>
                <span>⭐</span> 4.9 Rating
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CakePromoSection;
